export enum Events {
    OrderCreated = "order.created",
    OrderOpen = "order.open",
    Ping = "ping",
    Pong = "pong",
    Register = "register",
    Connect = "connect",
    Disconnect = "disconnect",
}
